(function () {
  const quote = (value) => {
    const raw = value.replace(/["']/g, '').trim();
    return raw ? `"${raw}"` : '';
  };

  // Full search submissions (header modal + results page form)
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action$="/search"]');
    if (!form) return;

    const input = form.querySelector('input[name="q"]');
    const term = input && quote(input.value);
    if (!term) return;

    e.preventDefault();
    const params = new URLSearchParams(new FormData(form));
    params.set('q', term);
    params.delete('options[prefix]');
    window.location.href = `${form.getAttribute('action')}?${params}`;
  });

  // Predictive search dropdown
  const nativeFetch = window.fetch;
  window.fetch = function (resource, init) {
    const href = typeof resource === 'string' ? resource : resource?.url;
    if (href && href.includes('/search/suggest')) {
      const url = new URL(href, location.origin);
      const term = quote(url.searchParams.get('q') || '');
      if (term) {
        url.searchParams.set('q', term);
        url.searchParams.delete('options[prefix]');
        return nativeFetch(url.toString(), init);
      }
    }
    return nativeFetch.apply(this, arguments);
  };
})();